import { Agent } from '@/containers/Agents/types';

// Extend Agent interface for canvassers with additional fields
export interface Canvasser extends Agent {
  // Additional fields from details endpoint
  jobs_details?: JobDetails[];
  created_at?: string;
  last_sign_in?: string;
}

export interface CanvasserDetails extends Canvasser {
  // Placeholder data for conversation stats
  conversation_stats: {
    started: number;
    replied: number;
    needs_reply?: number;
    opted_out: number;
    questions_answered: number;
  };
  // Placeholder data for current job
  current_job?: {
    id: string;
    name: string;
  };
}

export interface JobAssignment {
  job_id: string;
  job_name: string;
  status: string;
  assigned_at: string;
}

// Interface for the actual jobs_details structure returned by the API
export interface JobDetails {
  id: string;
  name: string;
  status: string;
  numOfAgents: number;
}

export type CanvasserFilter = 'all' | 'active' | 'inactive';
export type CanvasserSort =
  | 'display_name'
  | 'status'
  | 'started_convs'
  | 'replied_convs'
  | 'last_job';
export type SortDirection = 'asc' | 'desc';

export interface CanvasserFilters {
  filter: CanvasserFilter;
  search: string;
  sort: CanvasserSort;
  sortDirection: SortDirection;
}

// Bulk operation types
export interface BulkActivateCanvassersParams {
  canvasser_ids: string[];
}

export interface BulkDeactivateCanvassersParams {
  canvasser_ids: string[];
}

export interface BulkDeleteCanvassersParams {
  canvasser_ids: string[];
}

export interface BulkAssignToJobParams {
  canvasser_ids: string[];
  job_id: string;
}

export interface BulkUnassignFromJobParams {
  canvasser_ids: string[];
  job_id: string;
}

export interface ResetPasswordParams {
  canvasser_id: string;
  password: string;
}

// Table-specific types
export interface CanvasserTableParams {
  accountId: string;
  filter: CanvasserFilter;
  search?: string;
  sort: CanvasserSort;
  sortDirection: SortDirection;
}

// Placeholder data generation
export const generatePlaceholderStats = (canvasserId: string) => ({
  conversation_stats: {
    started: Math.floor(Math.random() * 500) + 50,
    replied: Math.floor(Math.random() * 200) + 20,
    opted_out: Math.floor(Math.random() * 20) + 1,
    questions_answered: Math.floor(Math.random() * 100) + 10,
  },
  current_job:
    Math.random() > 0.3
      ? {
          id: 'job-' + canvasserId,
          name: 'Sample Campaign ' + Math.floor(Math.random() * 100),
        }
      : undefined,
});
